// @ts-nocheck
import React, { useState } from 'react';
import { sx } from '../sx';

export default function AddCategoryModal({ names, onAdd, onClose }: { names: string[]; onAdd: (name: string) => void; onClose: () => void }) {
  const [name, setName] = useState('');
  const label = name.trim();
  const duplicate = !!label && (names || []).some(n => n.toLowerCase() === label.toLowerCase());
  const canAdd = !!label && !duplicate;
  const submit = () => {
    if (!canAdd) return;
    onAdd(label);
    onClose();
  };
  const onKey = e => {
    if (e.key === 'Enter') submit();
    else if (e.key === 'Escape') onClose();
  };

  return (
    <div onClick={onClose} style={sx(`position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`)}>
      <div role="dialog" aria-label="Add product category" onClick={e => e.stopPropagation()} style={sx(`width:100%;max-width:360px;background:#fff;border-radius:16px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5);padding:20px`)}>
        <div style={sx(`display:flex;align-items:center;gap:10px;margin-bottom:14px`)}>
          <div style={sx(`flex:1;min-width:0;font-size:15px;font-weight:600;color:var(--ink);letter-spacing:-0.01em`)}>Add product category</div>
          <button className="gmHover" onClick={onClose} aria-label="Close" style={sx(`flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid #DCE4F2;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:13px;line-height:1;cursor:pointer`)} data-hover="background:#F5F8FA">×</button>
        </div>
        <label style={sx(`display:block;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:var(--ink-4);margin-bottom:7px`)}>Category name</label>
        <input
          className="gmFocus"
          autoFocus
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={onKey}
          placeholder="e.g. Accessories"
          style={sx(`width:100%;height:38px;padding:0 12px;border:1px solid ${duplicate ? '#E5484D' : '#C8D4EA'};border-radius:8px;background:#fff;font-family:inherit;font-size:13px;color:var(--ink);outline:none;box-sizing:border-box`)}
        />
        <p style={sx(`margin:8px 0 0;font-size:11.5px;line-height:1.45;color:${duplicate ? '#E5484D' : 'var(--ink-4)'}`)}>
          {duplicate ? 'A category with this name already exists.' : 'Adds a manual row to Mix % and COGS %. It is saved in the app, not Snowflake. Every month is editable, including actuals, and accepts + or − values.'}
        </p>
        <div style={sx(`display:flex;justify-content:flex-end;gap:8px;margin-top:16px`)}>
          <button className="gmHover" onClick={onClose} style={sx(`height:32px;padding:0 14px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`)} data-hover="background:#F5F8FA">Cancel</button>
          <button onClick={submit} disabled={!canAdd} style={sx(`height:32px;padding:0 16px;border:none;border-radius:999px;background:${canAdd ? '#0052CD' : '#C8D4EA'};color:#fff;font-family:inherit;font-size:12.5px;font-weight:500;cursor:${canAdd ? 'pointer' : 'default'}`)}>Add category</button>
        </div>
      </div>
    </div>
  );
}
